import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { resetAllStores } from '../_core/resetAllStores';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useLazyStore from '../lazyStore/useLazyStore';
import useRouteStore from '../routeStore/useRouteStore';
import { signOutStore } from './signOutStore';
import { SignOutState } from './types/SignOutState';

const useSignOutStore: Store<SignOutState> = createStore({
  creator: signOutStore({
    resetAllStores,
    useApiStore: lazyDependency(() => useApiStore),
    useLazyStore: lazyDependency(() => useLazyStore),
    useRouteStore: lazyDependency(() => useRouteStore),
  }),
  id: 'signOut',
  middlewares: {
    devtools: true,
  },
});

export default useSignOutStore;
